

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.EntityList = (function () {

    function EntityList() {
        
        this.removeEmpty = true;
        this.onChange = null;
        this.selectedValue = 'com.greenmile.web.domain.Route';

        var buttonsEntity = {
            'com.greenmile.web.domain.Route': {label: "DataImport.UploadForm.RouteLabel"},
            'com.greenmile.web.domain.Location': {label: "DataImport.UploadForm.LocationLabel"},
            'com.greenmile.web.domain.Driver': {label: "DataImport.UploadForm.DriverLabel"},
            'com.greenmile.web.domain.Equipment': {label: "DataImport.UploadForm.EquipmentLabel"},
            'com.greenmile.web.domain.Sku': {label: "DataImport.UploadForm.SkuLabel"},
            'com.greenmile.web.domain.UserLocation': {label: "DataImport.UploadForm.DriverLocation"},
            'com.greenmile.web.domain.User': {label: "DataImport.UploadForm.UserLabel"},
            'com.greenmile.web.domain.PendingOrder': {label: "DataImport.UploadForm.PendingOrderLabel"}
        };

        this.getSelected = function() {
            return this.selectedValue;
        };
        
        this.afterChange = function () {
              
        };

        this.getRootEl = function() {
            var entityList = this.entityPicklist;
            if( !entityList.rootEl.childNodes.length ) {
                this.render();
            }

            return this.entityPicklist.rootEl;
        };

        this.render = function() {

            var fieldDomains = [];

            for(var i in buttonsEntity) {
                fieldDomains.push({
                    description: buttonsEntity[i].label,
                    value: i
                });
            }

            this.entityPicklist = new Monet.UI.Fields.Render({
                label: 'Greenmile.DataImport.EntityList',
                type: 'PICKLIST',
                fieldDomains: fieldDomains

            }).render();

            this.entityPicklist.setId('EntityList');
            
            if (this.removeEmpty) {
               this.entityPicklist.removeOptionByValue(' ');
                this.entityPicklist.setSelectedValue(this.selectedValue);
            }
            
            if (!this.onChange) {
                this.onChange = function (e) {
                    var selected = e.target.options[e.target.options.selectedIndex];
                    var editTemplate = document.querySelector("#editTemplate");
                    var deleteTemplate = document.querySelector("#deleteTemplate");
                    this.selectedValue = selected.value;
                    this.entityPicklist.setValue(this.selectedValue);
                    App.Forms.DataImport.MappingTemplate.refreshList();

                    if (editTemplate) {
                        editTemplate.style.display = "none";
                    }
                    if (deleteTemplate) {
                        deleteTemplate.style.display = "none";
                    }
                    this.afterChange();
                }.bind(this);
            }

            this.entityPicklist.input.addEventListener('change', this.onChange.bind(this));

            return this.entityPicklist.rootEl;
        };
    }

    return EntityList;
}());